import { createApp } from 'vue'
import app from './app.vue'
import './sass/main.scss'



createApp(app).mount('#app')
